import { Vocabulary } from './types'

// HSK2 Vocabulary - 300 words organized by category
export const vocabulary: Vocabulary[] = [
  // Greetings (问候语) - 15 words
  { id: 1, chinese: '你好', pinyin: 'nǐ hǎo', english: 'hello', category: 'greetings' },
  { id: 2, chinese: '再见', pinyin: 'zài jiàn', english: 'goodbye', category: 'greetings' },
  { id: 3, chinese: '谢谢', pinyin: 'xiè xie', english: 'thank you', category: 'greetings' },
  { id: 4, chinese: '不客气', pinyin: 'bù kè qi', english: "you're welcome", category: 'greetings' },
  { id: 5, chinese: '对不起', pinyin: 'duì bu qǐ', english: 'sorry', category: 'greetings' },
  { id: 6, chinese: '没关系', pinyin: 'méi guān xi', english: "it's okay", category: 'greetings' },
  { id: 7, chinese: '请', pinyin: 'qǐng', english: 'please', category: 'greetings' },
  { id: 8, chinese: '早上', pinyin: 'zǎo shang', english: 'morning', category: 'greetings' },
  { id: 9, chinese: '晚上', pinyin: 'wǎn shang', english: 'evening', category: 'greetings' },
  { id: 10, chinese: '欢迎', pinyin: 'huān yíng', english: 'welcome', category: 'greetings' },
  { id: 11, chinese: '认识', pinyin: 'rèn shi', english: 'to know', category: 'greetings' },
  { id: 12, chinese: '高兴', pinyin: 'gāo xìng', english: 'happy', category: 'greetings' },
  { id: 13, chinese: '名字', pinyin: 'míng zi', english: 'name', category: 'greetings' },
  { id: 14, chinese: '先生', pinyin: 'xiān sheng', english: 'Mr.', category: 'greetings' },
  { id: 15, chinese: '小姐', pinyin: 'xiǎo jie', english: 'Miss', category: 'greetings' },

  // Numbers (数字) - 25 words
  { id: 16, chinese: '一', pinyin: 'yī', english: 'one', category: 'numbers' },
  { id: 17, chinese: '二', pinyin: 'èr', english: 'two', category: 'numbers' },
  { id: 18, chinese: '三', pinyin: 'sān', english: 'three', category: 'numbers' },
  { id: 19, chinese: '四', pinyin: 'sì', english: 'four', category: 'numbers' },
  { id: 20, chinese: '五', pinyin: 'wǔ', english: 'five', category: 'numbers' },
  { id: 21, chinese: '六', pinyin: 'liù', english: 'six', category: 'numbers' },
  { id: 22, chinese: '七', pinyin: 'qī', english: 'seven', category: 'numbers' },
  { id: 23, chinese: '八', pinyin: 'bā', english: 'eight', category: 'numbers' },
  { id: 24, chinese: '九', pinyin: 'jiǔ', english: 'nine', category: 'numbers' },
  { id: 25, chinese: '十', pinyin: 'shí', english: 'ten', category: 'numbers' },
  { id: 26, chinese: '百', pinyin: 'bǎi', english: 'hundred', category: 'numbers' },
  { id: 27, chinese: '千', pinyin: 'qiān', english: 'thousand', category: 'numbers' },
  { id: 28, chinese: '万', pinyin: 'wàn', english: 'ten thousand', category: 'numbers' },
  { id: 29, chinese: '零', pinyin: 'líng', english: 'zero', category: 'numbers' },
  { id: 30, chinese: '两', pinyin: 'liǎng', english: 'two (for counting)', category: 'numbers' },
  { id: 31, chinese: '第一', pinyin: 'dì yī', english: 'first', category: 'numbers' },
  { id: 32, chinese: '第二', pinyin: 'dì èr', english: 'second', category: 'numbers' },
  { id: 33, chinese: '多少', pinyin: 'duō shao', english: 'how many', category: 'numbers' },
  { id: 34, chinese: '几', pinyin: 'jǐ', english: 'how many', category: 'numbers' },
  { id: 35, chinese: '半', pinyin: 'bàn', english: 'half', category: 'numbers' },
  { id: 36, chinese: '双', pinyin: 'shuāng', english: 'pair', category: 'numbers' },
  { id: 37, chinese: '个', pinyin: 'gè', english: 'piece/unit', category: 'numbers' },
  { id: 38, chinese: '岁', pinyin: 'suì', english: 'year (age)', category: 'numbers' },
  { id: 39, chinese: '元', pinyin: 'yuán', english: 'yuan', category: 'numbers' },
  { id: 40, chinese: '块', pinyin: 'kuài', english: 'kuai (money)', category: 'numbers' },

  // Family (家庭) - 20 words
  { id: 41, chinese: '爸爸', pinyin: 'bà ba', english: 'father/dad', category: 'family' },
  { id: 42, chinese: '妈妈', pinyin: 'mā ma', english: 'mother/mom', category: 'family' },
  { id: 43, chinese: '哥哥', pinyin: 'gē ge', english: 'older brother', category: 'family' },
  { id: 44, chinese: '姐姐', pinyin: 'jiě jie', english: 'older sister', category: 'family' },
  { id: 45, chinese: '弟弟', pinyin: 'dì di', english: 'younger brother', category: 'family' },
  { id: 46, chinese: '妹妹', pinyin: 'mèi mei', english: 'younger sister', category: 'family' },
  { id: 47, chinese: '爷爷', pinyin: 'yé ye', english: 'grandfather', category: 'family' },
  { id: 48, chinese: '奶奶', pinyin: 'nǎi nai', english: 'grandmother', category: 'family' },
  { id: 49, chinese: '叔叔', pinyin: 'shū shu', english: 'uncle', category: 'family' },
  { id: 50, chinese: '阿姨', pinyin: 'ā yi', english: 'aunt', category: 'family' },
  { id: 51, chinese: '儿子', pinyin: 'ér zi', english: 'son', category: 'family' },
  { id: 52, chinese: '女儿', pinyin: 'nǚ ér', english: 'daughter', category: 'family' },
  { id: 53, chinese: '孩子', pinyin: 'hái zi', english: 'child', category: 'family' },
  { id: 54, chinese: '家', pinyin: 'jiā', english: 'home/family', category: 'family' },
  { id: 55, chinese: '外公', pinyin: 'wài gōng', english: 'maternal grandpa', category: 'family' },
  { id: 56, chinese: '外婆', pinyin: 'wài pó', english: 'maternal grandma', category: 'family' },
  { id: 57, chinese: '朋友', pinyin: 'péng you', english: 'friend', category: 'family' },
  { id: 58, chinese: '家人', pinyin: 'jiā rén', english: 'family member', category: 'family' },
  { id: 59, chinese: '邻居', pinyin: 'lín jū', english: 'neighbor', category: 'family' },
  { id: 60, chinese: '人', pinyin: 'rén', english: 'person', category: 'family' },

  // Food (食物) - 30 words
  { id: 61, chinese: '饭', pinyin: 'fàn', english: 'rice/meal', category: 'food' },
  { id: 62, chinese: '米饭', pinyin: 'mǐ fàn', english: 'cooked rice', category: 'food' },
  { id: 63, chinese: '面条', pinyin: 'miàn tiáo', english: 'noodles', category: 'food' },
  { id: 64, chinese: '饺子', pinyin: 'jiǎo zi', english: 'dumpling', category: 'food' },
  { id: 65, chinese: '面包', pinyin: 'miàn bāo', english: 'bread', category: 'food' },
  { id: 66, chinese: '鸡蛋', pinyin: 'jī dàn', english: 'egg', category: 'food' },
  { id: 67, chinese: '肉', pinyin: 'ròu', english: 'meat', category: 'food' },
  { id: 68, chinese: '牛肉', pinyin: 'niú ròu', english: 'beef', category: 'food' },
  { id: 69, chinese: '鸡肉', pinyin: 'jī ròu', english: 'chicken', category: 'food' },
  { id: 70, chinese: '鱼', pinyin: 'yú', english: 'fish', category: 'food' },
  { id: 71, chinese: '菜', pinyin: 'cài', english: 'vegetable/dish', category: 'food' },
  { id: 72, chinese: '水果', pinyin: 'shuǐ guǒ', english: 'fruit', category: 'food' },
  { id: 73, chinese: '苹果', pinyin: 'píng guǒ', english: 'apple', category: 'food' },
  { id: 74, chinese: '香蕉', pinyin: 'xiāng jiāo', english: 'banana', category: 'food' },
  { id: 75, chinese: '西瓜', pinyin: 'xī guā', english: 'watermelon', category: 'food' },
  { id: 76, chinese: '茶', pinyin: 'chá', english: 'tea', category: 'food' },
  { id: 77, chinese: '咖啡', pinyin: 'kā fēi', english: 'coffee', category: 'food' },
  { id: 78, chinese: '水', pinyin: 'shuǐ', english: 'water', category: 'food' },
  { id: 79, chinese: '牛奶', pinyin: 'niú nǎi', english: 'milk', category: 'food' },
  { id: 80, chinese: '果汁', pinyin: 'guǒ zhī', english: 'juice', category: 'food' },
  { id: 81, chinese: '可乐', pinyin: 'kě lè', english: 'cola', category: 'food' },
  { id: 82, chinese: '好吃', pinyin: 'hǎo chī', english: 'delicious', category: 'food' },
  { id: 83, chinese: '甜', pinyin: 'tián', english: 'sweet', category: 'food' },
  { id: 84, chinese: '酸', pinyin: 'suān', english: 'sour', category: 'food' },
  { id: 85, chinese: '辣', pinyin: 'là', english: 'spicy', category: 'food' },
  { id: 86, chinese: '咸', pinyin: 'xián', english: 'salty', category: 'food' },
  { id: 87, chinese: '饿', pinyin: 'è', english: 'hungry', category: 'food' },
  { id: 88, chinese: '渴', pinyin: 'kě', english: 'thirsty', category: 'food' },
  { id: 89, chinese: '吃', pinyin: 'chī', english: 'to eat', category: 'food' },
  { id: 90, chinese: '喝', pinyin: 'hē', english: 'to drink', category: 'food' },

  // Animals (动物) - 20 words
  { id: 91, chinese: '狗', pinyin: 'gǒu', english: 'dog', category: 'animals' },
  { id: 92, chinese: '猫', pinyin: 'māo', english: 'cat', category: 'animals' },
  { id: 93, chinese: '鸟', pinyin: 'niǎo', english: 'bird', category: 'animals' },
  { id: 94, chinese: '马', pinyin: 'mǎ', english: 'horse', category: 'animals' },
  { id: 95, chinese: '牛', pinyin: 'niú', english: 'cow', category: 'animals' },
  { id: 96, chinese: '羊', pinyin: 'yáng', english: 'sheep', category: 'animals' },
  { id: 97, chinese: '猪', pinyin: 'zhū', english: 'pig', category: 'animals' },
  { id: 98, chinese: '鸡', pinyin: 'jī', english: 'chicken', category: 'animals' },
  { id: 99, chinese: '鸭', pinyin: 'yā', english: 'duck', category: 'animals' },
  { id: 100, chinese: '兔', pinyin: 'tù', english: 'rabbit', category: 'animals' },
  { id: 101, chinese: '老虎', pinyin: 'lǎo hǔ', english: 'tiger', category: 'animals' },
  { id: 102, chinese: '大象', pinyin: 'dà xiàng', english: 'elephant', category: 'animals' },
  { id: 103, chinese: '猴子', pinyin: 'hóu zi', english: 'monkey', category: 'animals' },
  { id: 104, chinese: '蛇', pinyin: 'shé', english: 'snake', category: 'animals' },
  { id: 105, chinese: '虫', pinyin: 'chóng', english: 'insect', category: 'animals' },
  { id: 106, chinese: '熊猫', pinyin: 'xióng māo', english: 'panda', category: 'animals' },
  { id: 107, chinese: '动物', pinyin: 'dòng wù', english: 'animal', category: 'animals' },
  { id: 108, chinese: '宠物', pinyin: 'chǒng wù', english: 'pet', category: 'animals' },
  { id: 109, chinese: '龙', pinyin: 'lóng', english: 'dragon', category: 'animals' },
  { id: 110, chinese: '鱼', pinyin: 'yú', english: 'goldfish', category: 'animals' },

  // Colors (颜色) - 15 words
  { id: 111, chinese: '颜色', pinyin: 'yán sè', english: 'color', category: 'colors' },
  { id: 112, chinese: '红', pinyin: 'hóng', english: 'red', category: 'colors' },
  { id: 113, chinese: '蓝', pinyin: 'lán', english: 'blue', category: 'colors' },
  { id: 114, chinese: '绿', pinyin: 'lǜ', english: 'green', category: 'colors' },
  { id: 115, chinese: '黄', pinyin: 'huáng', english: 'yellow', category: 'colors' },
  { id: 116, chinese: '白', pinyin: 'bái', english: 'white', category: 'colors' },
  { id: 117, chinese: '黑', pinyin: 'hēi', english: 'black', category: 'colors' },
  { id: 118, chinese: '橙', pinyin: 'chéng', english: 'orange', category: 'colors' },
  { id: 119, chinese: '紫', pinyin: 'zǐ', english: 'purple', category: 'colors' },
  { id: 120, chinese: '粉红', pinyin: 'fěn hóng', english: 'pink', category: 'colors' },
  { id: 121, chinese: '灰', pinyin: 'huī', english: 'gray', category: 'colors' },
  { id: 122, chinese: '棕色', pinyin: 'zōng sè', english: 'brown', category: 'colors' },
  { id: 123, chinese: '金色', pinyin: 'jīn sè', english: 'gold', category: 'colors' },
  { id: 124, chinese: '银色', pinyin: 'yín sè', english: 'silver', category: 'colors' },
  { id: 125, chinese: '深', pinyin: 'shēn', english: 'dark (color)', category: 'colors' },

  // Body (身体) - 15 words
  { id: 126, chinese: '身体', pinyin: 'shēn tǐ', english: 'body', category: 'body' },
  { id: 127, chinese: '头', pinyin: 'tóu', english: 'head', category: 'body' },
  { id: 128, chinese: '眼睛', pinyin: 'yǎn jing', english: 'eye', category: 'body' },
  { id: 129, chinese: '耳朵', pinyin: 'ěr duo', english: 'ear', category: 'body' },
  { id: 130, chinese: '鼻子', pinyin: 'bí zi', english: 'nose', category: 'body' },
  { id: 131, chinese: '嘴', pinyin: 'zuǐ', english: 'mouth', category: 'body' },
  { id: 132, chinese: '手', pinyin: 'shǒu', english: 'hand', category: 'body' },
  { id: 133, chinese: '脚', pinyin: 'jiǎo', english: 'foot', category: 'body' },
  { id: 134, chinese: '腿', pinyin: 'tuǐ', english: 'leg', category: 'body' },
  { id: 135, chinese: '胳膊', pinyin: 'gē bo', english: 'arm', category: 'body' },
  { id: 136, chinese: '头发', pinyin: 'tóu fa', english: 'hair', category: 'body' },
  { id: 137, chinese: '脸', pinyin: 'liǎn', english: 'face', category: 'body' },
  { id: 138, chinese: '牙', pinyin: 'yá', english: 'tooth', category: 'body' },
  { id: 139, chinese: '心', pinyin: 'xīn', english: 'heart', category: 'body' },
  { id: 140, chinese: '生病', pinyin: 'shēng bìng', english: 'to get sick', category: 'body' },

  // Time (时间) - 20 words
  { id: 141, chinese: '时间', pinyin: 'shí jiān', english: 'time', category: 'time' },
  { id: 142, chinese: '今天', pinyin: 'jīn tiān', english: 'today', category: 'time' },
  { id: 143, chinese: '明天', pinyin: 'míng tiān', english: 'tomorrow', category: 'time' },
  { id: 144, chinese: '昨天', pinyin: 'zuó tiān', english: 'yesterday', category: 'time' },
  { id: 145, chinese: '现在', pinyin: 'xiàn zài', english: 'now', category: 'time' },
  { id: 146, chinese: '以前', pinyin: 'yǐ qián', english: 'before', category: 'time' },
  { id: 147, chinese: '以后', pinyin: 'yǐ hòu', english: 'after', category: 'time' },
  { id: 148, chinese: '年', pinyin: 'nián', english: 'year', category: 'time' },
  { id: 149, chinese: '月', pinyin: 'yuè', english: 'month', category: 'time' },
  { id: 150, chinese: '日', pinyin: 'rì', english: 'day', category: 'time' },
  { id: 151, chinese: '星期', pinyin: 'xīng qī', english: 'week', category: 'time' },
  { id: 152, chinese: '周末', pinyin: 'zhōu mò', english: 'weekend', category: 'time' },
  { id: 153, chinese: '点', pinyin: 'diǎn', english: "o'clock", category: 'time' },
  { id: 154, chinese: '分', pinyin: 'fēn', english: 'minute', category: 'time' },
  { id: 155, chinese: '秒', pinyin: 'miǎo', english: 'second', category: 'time' },
  { id: 156, chinese: '小时', pinyin: 'xiǎo shí', english: 'hour', category: 'time' },
  { id: 157, chinese: '开始', pinyin: 'kāi shǐ', english: 'to start', category: 'time' },
  { id: 158, chinese: '结束', pinyin: 'jié shù', english: 'to end', category: 'time' },
  { id: 159, chinese: '快', pinyin: 'kuài', english: 'fast', category: 'time' },
  { id: 160, chinese: '慢', pinyin: 'màn', english: 'slow', category: 'time' },

  // Weather (天气) - 15 words
  { id: 161, chinese: '天气', pinyin: 'tiān qì', english: 'weather', category: 'weather' },
  { id: 162, chinese: '晴天', pinyin: 'qíng tiān', english: 'sunny day', category: 'weather' },
  { id: 163, chinese: '阴天', pinyin: 'yīn tiān', english: 'cloudy day', category: 'weather' },
  { id: 164, chinese: '下雨', pinyin: 'xià yǔ', english: 'to rain', category: 'weather' },
  { id: 165, chinese: '下雪', pinyin: 'xià xuě', english: 'to snow', category: 'weather' },
  { id: 166, chinese: '风', pinyin: 'fēng', english: 'wind', category: 'weather' },
  { id: 167, chinese: '云', pinyin: 'yún', english: 'cloud', category: 'weather' },
  { id: 168, chinese: '太阳', pinyin: 'tài yáng', english: 'sun', category: 'weather' },
  { id: 169, chinese: '月亮', pinyin: 'yuè liang', english: 'moon', category: 'weather' },
  { id: 170, chinese: '星星', pinyin: 'xīng xing', english: 'star', category: 'weather' },
  { id: 171, chinese: '热', pinyin: 'rè', english: 'hot', category: 'weather' },
  { id: 172, chinese: '冷', pinyin: 'lěng', english: 'cold', category: 'weather' },
  { id: 173, chinese: '暖', pinyin: 'nuǎn', english: 'warm', category: 'weather' },
  { id: 174, chinese: '凉', pinyin: 'liáng', english: 'cool', category: 'weather' },
  { id: 175, chinese: '温度', pinyin: 'wēn dù', english: 'temperature', category: 'weather' },

  // School (学校) - 20 words
  { id: 176, chinese: '学校', pinyin: 'xué xiào', english: 'school', category: 'school' },
  { id: 177, chinese: '老师', pinyin: 'lǎo shī', english: 'teacher', category: 'school' },
  { id: 178, chinese: '学生', pinyin: 'xué sheng', english: 'student', category: 'school' },
  { id: 179, chinese: '同学', pinyin: 'tóng xué', english: 'classmate', category: 'school' },
  { id: 180, chinese: '教室', pinyin: 'jiào shì', english: 'classroom', category: 'school' },
  { id: 181, chinese: '书', pinyin: 'shū', english: 'book', category: 'school' },
  { id: 182, chinese: '本子', pinyin: 'běn zi', english: 'notebook', category: 'school' },
  { id: 183, chinese: '笔', pinyin: 'bǐ', english: 'pen', category: 'school' },
  { id: 184, chinese: '字典', pinyin: 'zì diǎn', english: 'dictionary', category: 'school' },
  { id: 185, chinese: '电脑', pinyin: 'diàn nǎo', english: 'computer', category: 'school' },
  { id: 186, chinese: '作业', pinyin: 'zuò yè', english: 'homework', category: 'school' },
  { id: 187, chinese: '考试', pinyin: 'kǎo shì', english: 'exam', category: 'school' },
  { id: 188, chinese: '问题', pinyin: 'wèn tí', english: 'question', category: 'school' },
  { id: 189, chinese: '回答', pinyin: 'huí dá', english: 'to answer', category: 'school' },
  { id: 190, chinese: '学习', pinyin: 'xué xí', english: 'to study', category: 'school' },
  { id: 191, chinese: '教', pinyin: 'jiāo', english: 'to teach', category: 'school' },
  { id: 192, chinese: '懂', pinyin: 'dǒng', english: 'to understand', category: 'school' },
  { id: 193, chinese: '容易', pinyin: 'róng yì', english: 'easy', category: 'school' },
  { id: 194, chinese: '难', pinyin: 'nán', english: 'difficult', category: 'school' },
  { id: 195, chinese: '练习', pinyin: 'liàn xí', english: 'to practice', category: 'school' },

  // Places (地方) - 20 words
  { id: 196, chinese: '地方', pinyin: 'dì fang', english: 'place', category: 'places' },
  { id: 197, chinese: '厕所', pinyin: 'cè suǒ', english: 'bathroom', category: 'places' },
  { id: 198, chinese: '房间', pinyin: 'fáng jiān', english: 'room', category: 'places' },
  { id: 199, chinese: '公司', pinyin: 'gōng sī', english: 'company', category: 'places' },
  { id: 200, chinese: '商店', pinyin: 'shāng diàn', english: 'shop', category: 'places' },
  { id: 201, chinese: '超市', pinyin: 'chāo shì', english: 'supermarket', category: 'places' },
  { id: 202, chinese: '医院', pinyin: 'yī yuàn', english: 'hospital', category: 'places' },
  { id: 203, chinese: '银行', pinyin: 'yín háng', english: 'bank', category: 'places' },
  { id: 204, chinese: '饭店', pinyin: 'fàn diàn', english: 'restaurant', category: 'places' },
  { id: 205, chinese: '机场', pinyin: 'jī chǎng', english: 'airport', category: 'places' },
  { id: 206, chinese: '车站', pinyin: 'chē zhàn', english: 'station', category: 'places' },
  { id: 207, chinese: '公园', pinyin: 'gōng yuán', english: 'park', category: 'places' },
  { id: 208, chinese: '图书馆', pinyin: 'tú shū guǎn', english: 'library', category: 'places' },
  { id: 209, chinese: '办公室', pinyin: 'bàn gōng shì', english: 'office', category: 'places' },
  { id: 210, chinese: '城市', pinyin: 'chéng shì', english: 'city', category: 'places' },
  { id: 211, chinese: '国家', pinyin: 'guó jiā', english: 'country', category: 'places' },
  { id: 212, chinese: '中国', pinyin: 'zhōng guó', english: 'China', category: 'places' },
  { id: 213, chinese: '北京', pinyin: 'běi jīng', english: 'Beijing', category: 'places' },
  { id: 214, chinese: '上海', pinyin: 'shàng hǎi', english: 'Shanghai', category: 'places' },
  { id: 215, chinese: '泰国', pinyin: 'tài guó', english: 'Thailand', category: 'places' },

  // Verbs (动词) - 35 words
  { id: 216, chinese: '做', pinyin: 'zuò', english: 'to do', category: 'verbs' },
  { id: 217, chinese: '看', pinyin: 'kàn', english: 'to see/look', category: 'verbs' },
  { id: 218, chinese: '听', pinyin: 'tīng', english: 'to listen', category: 'verbs' },
  { id: 219, chinese: '说', pinyin: 'shuō', english: 'to speak', category: 'verbs' },
  { id: 220, chinese: '写', pinyin: 'xiě', english: 'to write', category: 'verbs' },
  { id: 221, chinese: '读', pinyin: 'dú', english: 'to read', category: 'verbs' },
  { id: 222, chinese: '走', pinyin: 'zǒu', english: 'to walk', category: 'verbs' },
  { id: 223, chinese: '跑', pinyin: 'pǎo', english: 'to run', category: 'verbs' },
  { id: 224, chinese: '坐', pinyin: 'zuò', english: 'to sit', category: 'verbs' },
  { id: 225, chinese: '站', pinyin: 'zhàn', english: 'to stand', category: 'verbs' },
  { id: 226, chinese: '睡', pinyin: 'shuì', english: 'to sleep', category: 'verbs' },
  { id: 227, chinese: '起', pinyin: 'qǐ', english: 'to get up', category: 'verbs' },
  { id: 228, chinese: '开', pinyin: 'kāi', english: 'to open', category: 'verbs' },
  { id: 229, chinese: '关', pinyin: 'guān', english: 'to close', category: 'verbs' },
  { id: 230, chinese: '买', pinyin: 'mǎi', english: 'to buy', category: 'verbs' },
  { id: 231, chinese: '卖', pinyin: 'mài', english: 'to sell', category: 'verbs' },
  { id: 232, chinese: '送', pinyin: 'sòng', english: 'to give/send', category: 'verbs' },
  { id: 233, chinese: '拿', pinyin: 'ná', english: 'to take', category: 'verbs' },
  { id: 234, chinese: '放', pinyin: 'fàng', english: 'to put', category: 'verbs' },
  { id: 235, chinese: '找', pinyin: 'zhǎo', english: 'to find', category: 'verbs' },
  { id: 236, chinese: '等', pinyin: 'děng', english: 'to wait', category: 'verbs' },
  { id: 237, chinese: '玩', pinyin: 'wán', english: 'to play', category: 'verbs' },
  { id: 238, chinese: '工作', pinyin: 'gōng zuò', english: 'to work', category: 'verbs' },
  { id: 239, chinese: '休息', pinyin: 'xiū xi', english: 'to rest', category: 'verbs' },
  { id: 240, chinese: '帮助', pinyin: 'bāng zhù', english: 'to help', category: 'verbs' },
  { id: 241, chinese: '告诉', pinyin: 'gào su', english: 'to tell', category: 'verbs' },
  { id: 242, chinese: '知道', pinyin: 'zhī dao', english: 'to know', category: 'verbs' },
  { id: 243, chinese: '会', pinyin: 'huì', english: 'can/to know how', category: 'verbs' },
  { id: 244, chinese: '想', pinyin: 'xiǎng', english: 'to think/want', category: 'verbs' },
  { id: 245, chinese: '爱', pinyin: 'ài', english: 'to love', category: 'verbs' },
  { id: 246, chinese: '喜欢', pinyin: 'xǐ huan', english: 'to like', category: 'verbs' },
  { id: 247, chinese: '要', pinyin: 'yào', english: 'to want', category: 'verbs' },
  { id: 248, chinese: '去', pinyin: 'qù', english: 'to go', category: 'verbs' },
  { id: 249, chinese: '来', pinyin: 'lái', english: 'to come', category: 'verbs' },
  { id: 250, chinese: '住', pinyin: 'zhù', english: 'to live', category: 'verbs' },
  { id: 301, chinese: '游泳', pinyin: 'yóu yǒng', english: 'to swim', category: 'verbs' },
  { id: 302, chinese: '飞', pinyin: 'fēi', english: 'to fly', category: 'verbs' },

  // Adjectives (形容词) - 25+ words
  { id: 251, chinese: '大', pinyin: 'dà', english: 'big', category: 'adjectives' },
  { id: 252, chinese: '小', pinyin: 'xiǎo', english: 'small', category: 'adjectives' },
  { id: 253, chinese: '多', pinyin: 'duō', english: 'many/much', category: 'adjectives' },
  { id: 254, chinese: '少', pinyin: 'shǎo', english: 'few/little', category: 'adjectives' },
  { id: 255, chinese: '新', pinyin: 'xīn', english: 'new', category: 'adjectives' },
  { id: 256, chinese: '旧', pinyin: 'jiù', english: 'old', category: 'adjectives' },
  { id: 257, chinese: '好', pinyin: 'hǎo', english: 'good', category: 'adjectives' },
  { id: 258, chinese: '坏', pinyin: 'huài', english: 'bad', category: 'adjectives' },
  { id: 259, chinese: '对', pinyin: 'duì', english: 'correct', category: 'adjectives' },
  { id: 260, chinese: '错', pinyin: 'cuò', english: 'wrong', category: 'adjectives' },
  { id: 261, chinese: '忙', pinyin: 'máng', english: 'busy', category: 'adjectives' },
  { id: 262, chinese: '累', pinyin: 'lèi', english: 'tired', category: 'adjectives' },
  { id: 263, chinese: '便宜', pinyin: 'pián yi', english: 'cheap', category: 'adjectives' },
  { id: 264, chinese: '贵', pinyin: 'guì', english: 'expensive', category: 'adjectives' },
  { id: 265, chinese: '远', pinyin: 'yuǎn', english: 'far', category: 'adjectives' },
  { id: 266, chinese: '近', pinyin: 'jìn', english: 'near', category: 'adjectives' },
  { id: 267, chinese: '高', pinyin: 'gāo', english: 'tall/high', category: 'adjectives' },
  { id: 268, chinese: '矮', pinyin: 'ǎi', english: 'short', category: 'adjectives' },
  { id: 269, chinese: '长', pinyin: 'cháng', english: 'long', category: 'adjectives' },
  { id: 270, chinese: '短', pinyin: 'duǎn', english: 'short', category: 'adjectives' },
  { id: 271, chinese: '宽', pinyin: 'kuān', english: 'wide', category: 'adjectives' },
  { id: 272, chinese: '窄', pinyin: 'zhǎi', english: 'narrow', category: 'adjectives' },
  { id: 273, chinese: '干净', pinyin: 'gān jìng', english: 'clean', category: 'adjectives' },
  { id: 274, chinese: '脏', pinyin: 'zāng', english: 'dirty', category: 'adjectives' },
  { id: 275, chinese: '漂亮', pinyin: 'piào liang', english: 'beautiful', category: 'adjectives' },
  { id: 303, chinese: '好看', pinyin: 'hǎo kàn', english: 'good-looking', category: 'adjectives' },

  // Daily (日常) - 25 words
  { id: 276, chinese: '网络', pinyin: 'wǎng luò', english: 'internet', category: 'daily' },
  { id: 277, chinese: '手机', pinyin: 'shǒu jī', english: 'mobile phone', category: 'daily' },
  { id: 278, chinese: '电视', pinyin: 'diàn shì', english: 'TV', category: 'daily' },
  { id: 279, chinese: '电话', pinyin: 'diàn huà', english: 'telephone', category: 'daily' },
  { id: 280, chinese: '衣服', pinyin: 'yī fu', english: 'clothes', category: 'daily' },
  { id: 281, chinese: '裤子', pinyin: 'kù zi', english: 'pants', category: 'daily' },
  { id: 282, chinese: '鞋', pinyin: 'xié', english: 'shoes', category: 'daily' },
  { id: 283, chinese: '桌子', pinyin: 'zhuō zi', english: 'table', category: 'daily' },
  { id: 284, chinese: '椅子', pinyin: 'yǐ zi', english: 'chair', category: 'daily' },
  { id: 285, chinese: '床', pinyin: 'chuáng', english: 'bed', category: 'daily' },
  { id: 286, chinese: '门', pinyin: 'mén', english: 'door', category: 'daily' },
  { id: 287, chinese: '窗', pinyin: 'chuāng', english: 'window', category: 'daily' },
  { id: 288, chinese: '车', pinyin: 'chē', english: 'car', category: 'daily' },
  { id: 289, chinese: '出租车', pinyin: 'chū zū chē', english: 'taxi', category: 'daily' },
  { id: 290, chinese: '飞机', pinyin: 'fēi jī', english: 'airplane', category: 'daily' },
  { id: 291, chinese: '票', pinyin: 'piào', english: 'ticket', category: 'daily' },
  { id: 292, chinese: '钱', pinyin: 'qián', english: 'money', category: 'daily' },
  { id: 293, chinese: '礼物', pinyin: 'lǐ wù', english: 'gift', category: 'daily' },
  { id: 294, chinese: '事情', pinyin: 'shì qing', english: 'matter/thing', category: 'daily' },
  { id: 295, chinese: '意思', pinyin: 'yì si', english: 'meaning', category: 'daily' },
  { id: 296, chinese: '旁边', pinyin: 'páng biān', english: 'beside', category: 'daily' },
  { id: 297, chinese: '前面', pinyin: 'qián mian', english: 'in front', category: 'daily' },
  { id: 298, chinese: '后面', pinyin: 'hòu mian', english: 'behind', category: 'daily' },
  { id: 299, chinese: '左边', pinyin: 'zuǒ bian', english: 'left side', category: 'daily' },
  { id: 300, chinese: '右边', pinyin: 'yòu bian', english: 'right side', category: 'daily' },
  // --- Added from full HSK1+HSK2 list (auto-appended) ---
  { id: 304, chinese: '喂', pinyin: 'wèi', english: 'hello (on the phone)', category: 'greetings' },
  { id: 305, chinese: '本', pinyin: 'běn', english: 'volume / book (measure word)', category: 'numbers' },
  { id: 306, chinese: '件', pinyin: 'jiàn', english: 'piece (measure word for clothes/matters)', category: 'numbers' },
  { id: 307, chinese: '张', pinyin: 'zhāng', english: 'sheet (measure word for flat objects)', category: 'numbers' },
  { id: 308, chinese: '次', pinyin: 'cì', english: 'time / occurrence', category: 'numbers' },
  { id: 309, chinese: '公斤', pinyin: 'gōng jīn', english: 'kilogram', category: 'numbers' },
  { id: 310, chinese: '些', pinyin: 'xiē', english: 'some / a few', category: 'numbers' },
  { id: 311, chinese: '丈夫', pinyin: 'zhàng fu', english: 'husband', category: 'family' },
  { id: 312, chinese: '妻子', pinyin: 'qī zi', english: 'wife', category: 'family' },
  { id: 313, chinese: '男人', pinyin: 'nán rén', english: 'man', category: 'family' },
  { id: 314, chinese: '女人', pinyin: 'nǚ rén', english: 'woman', category: 'family' },
  { id: 315, chinese: '我', pinyin: 'wǒ', english: 'I / me', category: 'family' },
  { id: 316, chinese: '你', pinyin: 'nǐ', english: 'you', category: 'family' },
  { id: 317, chinese: '您', pinyin: 'nín', english: 'you (polite)', category: 'family' },
  { id: 318, chinese: '他', pinyin: 'tā', english: 'he / him', category: 'family' },
  { id: 319, chinese: '她', pinyin: 'tā', english: 'she / her', category: 'family' },
  { id: 320, chinese: '它', pinyin: 'tā', english: 'it', category: 'family' },
  { id: 321, chinese: '我们', pinyin: 'wǒ men', english: 'we / us', category: 'family' },
  { id: 322, chinese: '大家', pinyin: 'dà jiā', english: 'everyone', category: 'family' },
  { id: 323, chinese: '羊肉', pinyin: 'yáng ròu', english: 'mutton / lamb', category: 'food' },
  { id: 324, chinese: '上午', pinyin: 'shàng wǔ', english: 'morning', category: 'time' },
  { id: 325, chinese: '中午', pinyin: 'zhōng wǔ', english: 'noon', category: 'time' },
  { id: 326, chinese: '下午', pinyin: 'xià wǔ', english: 'afternoon', category: 'time' },
  { id: 327, chinese: '时候', pinyin: 'shí hou', english: 'time / moment', category: 'time' },
  { id: 328, chinese: '分钟', pinyin: 'fēn zhōng', english: 'minute', category: 'time' },
  { id: 329, chinese: '去年', pinyin: 'qù nián', english: 'last year', category: 'time' },
  { id: 330, chinese: '明年', pinyin: 'míng nián', english: 'next year', category: 'time' },
  { id: 331, chinese: '号', pinyin: 'hào', english: 'date (day of month)', category: 'time' },
  { id: 332, chinese: '雪', pinyin: 'xuě', english: 'snow', category: 'weather' },
  { id: 333, chinese: '晴', pinyin: 'qíng', english: 'sunny', category: 'weather' },
  { id: 334, chinese: '阴', pinyin: 'yīn', english: 'cloudy', category: 'weather' },
  { id: 335, chinese: '字', pinyin: 'zì', english: 'character / word', category: 'school' },
  { id: 336, chinese: '汉语', pinyin: 'hàn yǔ', english: 'Chinese language', category: 'school' },
  { id: 337, chinese: '课', pinyin: 'kè', english: 'class / lesson', category: 'school' },
  { id: 338, chinese: '题', pinyin: 'tí', english: 'problem (exam/exercise)', category: 'school' },
  { id: 339, chinese: '上', pinyin: 'shàng', english: 'up / above', category: 'places' },
  { id: 340, chinese: '这', pinyin: 'zhè', english: 'this', category: 'places' },
  { id: 341, chinese: '这儿', pinyin: 'zhè r', english: 'here', category: 'places' },
  { id: 342, chinese: '那', pinyin: 'nà', english: 'that', category: 'places' },
  { id: 343, chinese: '那儿', pinyin: 'nà r', english: 'there', category: 'places' },
  { id: 344, chinese: '哪', pinyin: 'nǎ', english: 'which', category: 'places' },
  { id: 345, chinese: '哪儿', pinyin: 'nǎ r', english: 'where', category: 'places' },
  { id: 346, chinese: '是', pinyin: 'shì', english: 'be (is/am/are)', category: 'verbs' },
  { id: 347, chinese: '有', pinyin: 'yǒu', english: 'have', category: 'verbs' },
  { id: 348, chinese: '在', pinyin: 'zài', english: 'be at / in', category: 'verbs' },
  { id: 349, chinese: '看见', pinyin: 'kàn jiàn', english: 'see', category: 'verbs' },
  { id: 350, chinese: '说话', pinyin: 'shuō huà', english: 'talk', category: 'verbs' },
  { id: 351, chinese: '问', pinyin: 'wèn', english: 'ask', category: 'verbs' },
  { id: 352, chinese: '叫', pinyin: 'jiào', english: 'call / be named', category: 'verbs' },
  { id: 353, chinese: '笑', pinyin: 'xiào', english: 'laugh / smile', category: 'verbs' },
  { id: 354, chinese: '穿', pinyin: 'chuān', english: 'wear', category: 'verbs' },
  { id: 355, chinese: '回', pinyin: 'huí', english: 'return', category: 'verbs' },
  { id: 356, chinese: '进', pinyin: 'jìn', english: 'enter', category: 'verbs' },
  { id: 357, chinese: '出', pinyin: 'chū', english: 'exit', category: 'verbs' },
  { id: 358, chinese: '到', pinyin: 'dào', english: 'arrive', category: 'verbs' },
  { id: 359, chinese: '给', pinyin: 'gěi', english: 'give', category: 'verbs' },
  { id: 360, chinese: '介绍', pinyin: 'jiè shào', english: 'introduce', category: 'verbs' },
  { id: 361, chinese: '让', pinyin: 'ràng', english: 'let / allow', category: 'verbs' },
  { id: 362, chinese: '希望', pinyin: 'xī wàng', english: 'hope', category: 'verbs' },
  { id: 363, chinese: '完', pinyin: 'wán', english: 'finish', category: 'verbs' },
  { id: 364, chinese: '准备', pinyin: 'zhǔn bèi', english: 'prepare', category: 'verbs' },
  { id: 365, chinese: '能', pinyin: 'néng', english: 'can / be able to', category: 'verbs' },
  { id: 366, chinese: '可以', pinyin: 'kě yǐ', english: 'can / may', category: 'verbs' },
  { id: 367, chinese: '快乐', pinyin: 'kuài lè', english: 'joyful', category: 'adjectives' },
  { id: 368, chinese: '睡觉', pinyin: 'shuì jiào', english: 'sleep', category: 'daily' },
  { id: 369, chinese: '起床', pinyin: 'qǐ chuáng', english: 'get up', category: 'daily' },
  { id: 370, chinese: '上班', pinyin: 'shàng bān', english: 'go to work', category: 'daily' },
  { id: 371, chinese: '洗', pinyin: 'xǐ', english: 'wash', category: 'daily' },
  { id: 372, chinese: '打电话', pinyin: 'dǎ diàn huà', english: 'make a phone call', category: 'daily' },
  { id: 373, chinese: '跑步', pinyin: 'pǎo bù', english: 'run / jog', category: 'daily' },
  { id: 374, chinese: '踢足球', pinyin: 'tī zú qiú', english: 'play soccer', category: 'daily' },
  { id: 375, chinese: '打篮球', pinyin: 'dǎ lán qiú', english: 'play basketball', category: 'daily' },
  { id: 376, chinese: '运动', pinyin: 'yùn dòng', english: 'exercise', category: 'daily' },
  { id: 377, chinese: '跳舞', pinyin: 'tiào wǔ', english: 'dance', category: 'daily' },
  { id: 378, chinese: '唱歌', pinyin: 'chàng gē', english: 'sing', category: 'daily' },
  { id: 379, chinese: '旅游', pinyin: 'lǚ yóu', english: 'travel', category: 'daily' },
  { id: 380, chinese: '医生', pinyin: 'yī shēng', english: 'doctor', category: 'daily' },
  { id: 381, chinese: '服务员', pinyin: 'fú wù yuán', english: 'waiter / waitress', category: 'daily' },
  { id: 382, chinese: '东西', pinyin: 'dōng xi', english: 'thing', category: 'daily' },
  { id: 383, chinese: '电影', pinyin: 'diàn yǐng', english: 'movie', category: 'daily' },
  { id: 384, chinese: '公共汽车', pinyin: 'gōng gòng qì chē', english: 'bus', category: 'daily' },
  { id: 385, chinese: '火车', pinyin: 'huǒ chē', english: 'train', category: 'daily' },
  { id: 386, chinese: '自行车', pinyin: 'zì xíng chē', english: 'bicycle', category: 'daily' },
  { id: 387, chinese: '船', pinyin: 'chuán', english: 'boat', category: 'daily' },
  { id: 388, chinese: '报纸', pinyin: 'bào zhǐ', english: 'newspaper', category: 'daily' },
  { id: 389, chinese: '药', pinyin: 'yào', english: 'medicine', category: 'daily' },
  { id: 390, chinese: '杯子', pinyin: 'bēi zi', english: 'cup', category: 'daily' },
  { id: 391, chinese: '生日', pinyin: 'shēng rì', english: 'birthday', category: 'daily' },
  { id: 392, chinese: '谁', pinyin: 'shéi', english: 'who', category: 'daily' },
  { id: 393, chinese: '什么', pinyin: 'shén me', english: 'what', category: 'daily' },
  { id: 394, chinese: '怎么', pinyin: 'zěn me', english: 'how', category: 'daily' },
  { id: 395, chinese: '怎么样', pinyin: 'zěn me yàng', english: 'how is it', category: 'daily' },
  { id: 396, chinese: '为什么', pinyin: 'wèi shén me', english: 'why', category: 'daily' },
  { id: 397, chinese: '和', pinyin: 'hé', english: 'and', category: 'daily' },
  { id: 398, chinese: '但是', pinyin: 'dàn shì', english: 'but', category: 'daily' },
  { id: 399, chinese: '因为', pinyin: 'yīn wèi', english: 'because', category: 'daily' },
  { id: 400, chinese: '所以', pinyin: 'suǒ yǐ', english: 'therefore', category: 'daily' },
  { id: 401, chinese: '从', pinyin: 'cóng', english: 'from', category: 'daily' },
  { id: 402, chinese: '向', pinyin: 'xiàng', english: 'towards', category: 'daily' },
  { id: 403, chinese: '离', pinyin: 'lí', english: 'away from', category: 'daily' },
  { id: 404, chinese: '比', pinyin: 'bǐ', english: 'than', category: 'daily' },
  { id: 405, chinese: '很', pinyin: 'hěn', english: 'very', category: 'daily' },
  { id: 406, chinese: '非常', pinyin: 'fēi cháng', english: 'extremely', category: 'daily' },
  { id: 407, chinese: '太', pinyin: 'tài', english: 'too', category: 'daily' },
  { id: 408, chinese: '最', pinyin: 'zuì', english: 'most', category: 'daily' },
  { id: 409, chinese: '真', pinyin: 'zhēn', english: 'really', category: 'daily' },
  { id: 410, chinese: '都', pinyin: 'dōu', english: 'all / both', category: 'daily' },
  { id: 411, chinese: '不', pinyin: 'bù', english: 'not', category: 'daily' },
  { id: 412, chinese: '没', pinyin: 'méi', english: 'not have', category: 'daily' },
  { id: 413, chinese: '每', pinyin: 'měi', english: 'every', category: 'daily' },
  { id: 414, chinese: '也', pinyin: 'yě', english: 'also / too', category: 'daily' },
  { id: 415, chinese: '还', pinyin: 'hái', english: 'still / yet', category: 'daily' },
  { id: 416, chinese: '再', pinyin: 'zài', english: 'again', category: 'daily' },
  { id: 417, chinese: '就', pinyin: 'jiù', english: 'then / just', category: 'daily' },
  { id: 418, chinese: '别', pinyin: 'bié', english: "don't", category: 'daily' },
  { id: 419, chinese: '已经', pinyin: 'yǐ jīng', english: 'already', category: 'daily' },
  { id: 420, chinese: '一起', pinyin: 'yì qǐ', english: 'together', category: 'daily' },
  { id: 421, chinese: '可能', pinyin: 'kě néng', english: 'maybe / possible', category: 'daily' },
  { id: 422, chinese: '正在', pinyin: 'zhèng zài', english: 'in the process of', category: 'daily' },
  { id: 423, chinese: '一点', pinyin: 'yì diǎn', english: 'a little', category: 'daily' },
  { id: 424, chinese: '的', pinyin: 'de', english: 'possessive particle', category: 'daily' },
  { id: 425, chinese: '得', pinyin: 'de', english: 'complement particle', category: 'daily' },
  { id: 426, chinese: '了', pinyin: 'le', english: 'completed aspect particle', category: 'daily' },
  { id: 427, chinese: '着', pinyin: 'zhe', english: 'continuous aspect particle', category: 'daily' },
  { id: 428, chinese: '过', pinyin: 'guo', english: 'experiential particle', category: 'daily' },
  { id: 429, chinese: '吗', pinyin: 'ma', english: 'yes/no question particle', category: 'daily' },
  { id: 430, chinese: '呢', pinyin: 'ne', english: 'what-about question particle', category: 'daily' },
  { id: 431, chinese: '吧', pinyin: 'ba', english: 'suggestion particle', category: 'daily' },
]

export function getWordsByCategory(category: string): Vocabulary[] {
  return vocabulary.filter(word => word.category === category)
}

export function getWordsByCategories(categories: string[]): Vocabulary[] {
  return vocabulary.filter(word => categories.includes(word.category))
}

export function getRandomWords(count: number, exclude?: number[], categories?: string[], strictMode = false): Vocabulary[] {
  let pool = categories && categories.length > 0
    ? vocabulary.filter(word => categories.includes(word.category))
    : vocabulary

  // Try excluding used words; if not enough left, use full pool (allow repeats) unless strictMode
  let available = exclude && exclude.length > 0
    ? pool.filter(word => !exclude.includes(word.id))
    : pool
  
  if (!strictMode && available.length < count) {
    available = pool
  }
  
  const shuffled = [...available].sort(() => Math.random() - 0.5)
  return shuffled.slice(0, count)
}

export function getWordById(id: number): Vocabulary | undefined {
  return vocabulary.find(word => word.id === id)
}
